// removed by extract-text-webpack-plugin
module.exports = {"verticallyCentered":"SimpleModal-style__verticallyCentered__3IxZG","horizontallyRight":"SimpleModal-style__horizontallyRight__iKj-D","horizontallyCentered":"SimpleModal-style__horizontallyCentered__33pTJ","verticallyHorizontallyCentered":"SimpleModal-style__verticallyHorizontallyCentered__H-hlN"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/components/SimpleModal/SimpleModal-style.scss
// module id = 2372
// module chunks = 63